import "./ServicesIconList.scss";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow_right.svg";
import AtmLink from "../../atoms/atmLink/AtmLink";
import { ENUMS } from "../../../enums/enums";
import { useTranslation } from "react-i18next";

const ServicesIconList = (props) => {
  const { t } = useTranslation();
  const serviceListIconList = [
    {
      text: t("serviceListIcon1"),
      forPanel: "panel-1",
    },
    {
      text: t("serviceListIcon2"),
      forPanel: "panel-2",
    },
    {
      text: t("serviceListIcon3"),
      forPanel: "panel-3",
    },
    {
      text: t("serviceListIcon4"),
      forPanel: "panel-4",
    },
    {
      text: t("serviceListIcon5"),
      forPanel: "panel-5",
    },
  ];

  const serviceListPanels = [
    {
      id: "panel-1",
      description1: t("serviceListPanel1Description1"),
      description2: t("serviceListPanel1Description2"),
    },
    {
      id: "panel-2",
      description1: t("serviceListPanel2Description1"),
      description2: t("serviceListPanel2Description2"),
    },
    {
      id: "panel-3",
      description1: t("serviceListPanel3Description1"),
      description2: t("serviceListPanel3Description2"),
    },
    {
      id: "panel-4",
      description1: t("serviceListPanel4Description1"),
      description2: t("serviceListPanel4Description2"),
    },
    {
      id: "panel-5",
      description1: t("serviceListPanel5Description1"),
      description2: t("serviceListPanel5Description2"),
    },
  ];

  return (
    <>
      <ul className={"mdl-services-icon-list"}>
        {serviceListIconList.map((service, index) => {
          return (
            <ServicesListItem
              servicesPage={props.servicesPage}
              forPanel={service.forPanel}
              active={index === 0}
              text={service.text}
              key={service.text}
            />
          );
        })}
      </ul>
      {props.servicesPage ? (
        <div className={"mdl-services-icon-list__panels"}>
          {serviceListPanels.map((panel, index) => {
            return (
              <div
                className={`mdl-services-icon-list__panels-item ${
                  index === 0 ? "active" : ""
                }`}
                id={panel.id}
              >
                <p className="mb-md">{panel.description1}</p>
                {/* <p className='text-primary font-small'>{t("serviceListDescriptionHeading")}</p> */}
                <p className="font-small">{panel.description2}</p>
              </div>
            );
          })}
        </div>
      ) : (
        ""
      )}
    </>
  );
};

const ServicesListItem = (props) => {
  const handleServicesListItemClick = () => {
    const currentActivePanel = document.querySelector(
      ".mdl-services-icon-list__panels-item.active"
    );
    currentActivePanel.classList.remove("active");
    const panel = document.querySelector(
      `.mdl-services-icon-list__panels-item#${props.forPanel}`
    );
    panel.classList.add("active");

    const currentActiveTab = document.querySelector(
      ".mdl-services-icon-list__item.active"
    );
    currentActiveTab.classList.remove("active");
    const tab = document.querySelector(
      `.mdl-services-icon-list__item#${props.forPanel}`
    );
    tab.classList.add("active");
  };

  if (props.servicesPage) {
    return (
      <li
        className={`mdl-services-icon-list__item ${
          props.active ? "active" : ""
        }`}
        id={props.forPanel}
        onClick={handleServicesListItemClick}
      >
        <div className={"mdl-services-icon-list__arrow"}>
          <ArrowRight />
        </div>
        {props.text}
      </li>
    );
  }

  return (
    <li>
      <AtmLink
        className={"mdl-services-icon-list__item"}
        to={ENUMS.ROUTE_SERVICES}
        noStyle
      >
        <div className={"mdl-services-icon-list__arrow"}>
          <ArrowRight />
        </div>
        {props.text}
      </AtmLink>
    </li>
  );
};

export default ServicesIconList;
